import Box from '@mui/material/Box';
import Shimmer from './Shimmer';

// Skeleton for the Tests catalogue grid.
//
// Mirrors the v5 test card exactly — same 290px track, 24px radius, 1.5px
// border, 22px padding and 240px floor — so the grid does not reflow when
// the rows arrive. The previous version still drew the pre-v5 card: an
// emoji, a save-percent pill and a pill-shaped CTA, on fixed 1/2/3/4
// column breakpoints, none of which the page has now.
const TestCardShimmer = () => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      gap: 1.75,
      minHeight: 240,
      p: '22px',
      borderRadius: '24px',
      bgcolor: '#FFFFFF',
      border: '1.5px solid var(--tl-line)',
      boxShadow: '0 10px 24px -18px rgba(11,43,39,0.35)',
    }}
  >
    {/* department tag opposite the turnaround */}
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', gap: 1 }}>
      <Shimmer width={96} height={25} rounded={999} />
      <Shimmer width={78} height={16} rounded={4} />
    </Box>

    {/* test name — two lines, as most names wrap at this width */}
    <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '8px' }}>
      <Shimmer width="92%" height={21} rounded={6} />
      <Shimmer width="58%" height={21} rounded={6} />
    </Box>

    {/* "Sample: …" and the preparation line */}
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
      <Shimmer width="64%" height={14} rounded={4} />
      <Shimmer width="48%" height={14} rounded={4} />
    </Box>

    {/* Add to visit */}
    <Shimmer width="100%" height={44} rounded={14} />
  </Box>
);

const TestsShimmer = ({ count = 12 }) => (
  <Box
    aria-label="Loading tests"
    sx={{
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(min(100%, 290px), 1fr))',
      gap: 1.5,
      width: '100%',
    }}
  >
    {Array.from({ length: count }).map((_, i) => <TestCardShimmer key={i} />)}
  </Box>
);

export default TestsShimmer;
